import { Component, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-access-error',
    templateUrl: './access-error.component.html',
    styleUrl: './access-error.component.scss',
  standalone: true
})
export class AccessErrorComponent {
  private authService = inject(AuthService);


  OnLoginAgain(): void {
    this.authService.Logout();
  }

}
